export const SUPPORTED_CARD_TYPES = ['SAVE_THE_DATE', 'INVITATION'];
